import axios from 'axios'

const state = {
    companies: []
};

const actions = {
    getAllCompanies ({commit}) {
        axios.post('api/companies/get-companies-lite-version').then(
            response => {
                commit('recieve_companies', response.data.companies)
            }
        ).catch(errors =>{
            console.log(errors);
        })
    },
};

const mutations = {
    recieve_companies (state, companies) {
        state.companies = companies;
    },
};

const getters = {
    allCompanies (state) {
        return state.companies
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
